module.exports = __webpack_public_path__ + "assets/images/project/head/Ray_Chiu_Po-jui.jpg?v=ce97532e";